import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
import { goToCheckout } from '../utils/checkout';
type KitPurchaseCardProps = {
  id?: string;
};
const KIT_IMAGE = 'https://cdn.magicpatterns.com/uploads/tLMwVRmFZMdaPSk4RHPedW/Kit_terapeutico_Constelacion_Familiar.webp';
const BENEFITS = ['350 preguntas para explorar el sistema familiar.', 'Genogramas y mapas de relaciones familiares.', 'Cartas sistémicas y tarjetas de representación.', 'Guiones para organizar tus sesiones.', 'Fichas de seguimiento de consultantes.', 'Dinámicas y ejercicios de integración.'];
const TRUST_BADGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/qVkpSuniAMH5JHw8tLQe1p/png-clipart-safe-purchase-payment-security-shop-shopping-online-store-e-commerce-sign-green-texta.png',
  alt: 'Compra segura'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oPVTf9nAcj9aaX7XFUU66W/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png',
  alt: 'Garantía de 7 días'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t6N3f2YPmVeB9mS6ZbJr2N/Diseno_sin_titulo.png',
  alt: 'Acceso de por vida'
}];
export function KitPurchaseCard({
  id
}: KitPurchaseCardProps) {
  const prefersReducedMotion = useReducedMotion();
  return <motion.article id={id} initial={prefersReducedMotion ? undefined : {
    opacity: 0,
    y: 18
  }} whileInView={prefersReducedMotion ? undefined : {
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.4,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto max-w-[480px] overflow-hidden rounded-[28px] border border-[#ded2ec] bg-[#fffdf8] p-4 shadow-[0_20px_50px_-34px_rgba(46,16,101,0.68)] sm:p-6" data-id="element-219" data-mp="37p1om3p5s1nz">
      <header className="text-center" data-id="element-220" data-mp="2k08p5x9bvbom">
        <p className="inline-flex rounded-full border border-[#d9cbea] bg-[#f1eafb] px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#5b2a91] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-221" data-mp="2jz7dproegn6d">
          Kit profesional · Material digital
        </p>
        <h2 className="mt-4 font-['Playfair_Display',_serif] text-[31px] font-bold leading-[1.05] text-[#2e1065] sm:text-[38px]" data-id="element-222" data-mp="2adfwe2f5r41h">
          Llevate tu Kit Profesional de Constelaciones Familiares
        </h2>
      </header>

      <img src={KIT_IMAGE} alt="Kit Profesional de Constelaciones Familiares con libro y herramientas terapéuticas" className="mx-auto mt-5 block h-auto w-full max-w-md object-contain" data-id="element-223" data-mp="21c890fe6jnm6" />

      <section className="mt-4 rounded-2xl border border-[#ded2ec] bg-[#f3edfb] p-4 text-left sm:p-5" data-id="element-224" data-mp="2t4ywo1hss3zt">
        <h3 className="text-center text-[11px] font-extrabold uppercase tracking-[0.13em] text-[#4b257a] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-225" data-mp="2f9dae22y7yb3">
          Todo lo que incluye tu kit
        </h3>
        <ul className="mt-4 grid gap-x-4 gap-y-3 text-[13px] font-semibold leading-snug text-[#32185e] [font-family:'Plus_Jakarta_Sans',sans-serif] sm:grid-cols-2 sm:text-[14px]" data-id="element-226" data-mp="37yajpfp6mkrp">
          {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-2" data-id="element-227" data-mp="3i4bqloprp2om">
              <CheckIcon size={16} strokeWidth={3} className="mt-0.5 shrink-0 text-[#6b3da1]" aria-hidden="true" data-id="element-228" data-mp="3i1zehs6oxmjh" />
              <span data-id="element-229" data-mp="3vxbae2wl1j1z">{benefit}</span>
            </li>)}
        </ul>
        <p className="mt-4 border-t border-[#ded2ec] pt-3 text-center text-[12px] font-semibold text-[#5f526d] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-230" data-mp="3qx5kos9vi6mj">
          Descarga inmediata · PDF para imprimir · Acceso de por vida
        </p>
      </section>

      <section className="mt-4 rounded-2xl border border-[#d9cbea] bg-[#eee5f8] px-4 py-5 text-center sm:px-5" data-id="element-231" data-mp="3d58y13qz4oxj">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-[#5b2a91] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-232" data-mp="384umhbq5ywur">
          Precio promocional
        </p>
        <p className="mt-2 text-[16px] font-semibold text-[#82738f] line-through [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-233" data-mp="ng6ppn4w8xta">
          $39.980 ARS
        </p>
        <span className="mt-2 inline-flex rounded-full bg-[#e5f6d4] px-3 py-1 text-[11px] font-extrabold tracking-[0.08em] text-[#4c7f10] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-234" data-mp="2t6aaw35l2abi">
          50% OFF
        </span>
        <p className="mt-3 whitespace-nowrap text-[44px] font-black leading-none tracking-tight text-[#2e1065] [font-family:'Plus_Jakarta_Sans',sans-serif] sm:text-[50px]" data-id="element-235" data-mp="373grbr2u3wxk">
          $19.990 <span className="text-lg font-bold tracking-normal sm:text-xl" data-id="element-236" data-mp="3c0z1tlwi2k7o">ARS</span>
        </p>
      </section>

      <button onClick={goToCheckout} className="mt-4 w-full rounded-full bg-[#84cc16] px-6 py-5 text-[14px] font-extrabold uppercase tracking-[0.14em] text-white shadow-[0_16px_30px_-14px_rgba(101,163,13,0.65)] transition-[background-color,box-shadow,transform] duration-200 ease-out hover:bg-[#74b914] hover:shadow-[0_18px_34px_-14px_rgba(101,163,13,0.75)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#65a30d] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-237" data-mp="3lsmmn3yjx306">
        Acceder ahora
      </button>

      <img src="https://cdn.magicpatterns.com/uploads/hiqmi5MWbGumweAsyJRQdQ/capture_260410_163646.png" alt="Pago seguro garantizado con Visa, Mastercard, American Express y Mercado Pago" className="mx-auto mt-4 h-auto w-full max-w-[320px]" data-id="element-238" data-mp="1j826uc9vkkum" />
      <div className="mx-auto mt-4 grid max-w-[280px] grid-cols-3 items-center gap-3" aria-label="Garantías de compra" data-id="element-239" data-mp="26u8ozrd0jgyk">
        {TRUST_BADGES.map(badge => <img key={badge.alt} src={badge.src} alt={badge.alt} className="mx-auto h-12 w-auto object-contain" data-id="element-240" data-mp="1y2ynndvr2gjb" />)}
      </div>
      <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-[11px] font-semibold text-[#665873] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-241" data-mp="2qjj5h7kl25xq">
        <LockKeyholeIcon size={14} className="shrink-0 text-[#6b3da1]" aria-hidden="true" data-id="element-242" data-mp="2lrhv5r6z6pac" />
        Compra segura · Descarga inmediata · Acceso de por vida
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-[0.12em] text-[#6b4fa0] [font-family:'Plus_Jakarta_Sans',sans-serif]" data-id="element-243" data-mp="39n304sq75ga8">
        <ShieldCheckIcon size={14} aria-hidden="true" data-id="element-244" data-mp="2zxt81cvcrxm4" /> Pago 100% seguro y protegido
      </div>
    </motion.article>;
}